import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import media from 'theme/media';

const ContainerWide = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 24px;
    padding-right: 24px;

    ${media.tablet648} {
        max-width: 640px;
        padding-left: 64px;
        padding-right: 64px;
    }

    ${media.desktop1352} {
        max-width: 1280px;
        padding-left: 160px;
        padding-right: 160px;
    }
`;
const ContainerNarrow = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 24px;
    padding-right: 24px;

    ${media.tablet648} {
        max-width: 620px;
        padding-left: 64px;
        padding-right: 64px;
    }
`;
export const SectionContainer = (props) => {
    return (
        <React.Fragment>
            {props.dimension === 'wide' && <ContainerWide>{props.children}</ContainerWide>}
            {props.dimension === 'narrow' && <ContainerNarrow>{props.children}</ContainerNarrow>}
        </React.Fragment>
    );
};

SectionContainer.propTypes = {
    children: PropTypes.any,
    dimension: PropTypes.oneOf(['wide', 'narrow']),
};
